import styled from 'styled-components';

const H1 = styled.h1`
  color: ${({ theme }) => theme.blue500};
  font-size: 36px;
`;

export default H1;
